import i18n from '@/i18n';
import { placeholder, type CTableColumns } from '@bluevision/tools';
import type { FilterConfig } from '@bluevision/components/types/components/Filter/type';
import { enterTokenSeparators } from '@/data';
import { PersonnelManageAPI } from '@/services/userManage/interface';
import { TableCell } from '@bluevision/components';

export const { ROLE, ROLE_LIST } = PersonnelManageAPI;

/** 管理员 */
export const MANAGER = 'manager';

/** 用户状态 */
export enum ACTIVE {
  ENABLE = 1,
  UN_ENABLE = 0,
}

/** 状态映射 */
export const ACTIVE_LIST = {
  [ACTIVE.ENABLE]: 'enable',
  [ACTIVE.UN_ENABLE]: 'un_enable',
} as const;

/** 格式化用户组 */
const formatUserGroups = (userGroups: string) => {
  if (!userGroups) return placeholder;
  return i18n.t(userGroups) || placeholder;
};

// 导出选项，暂时屏蔽
// const exportOptions = (groupList: GroupList): OperateOption[] => [
//   {
//     title: 'personnel_name',
//     key: 'contactName',
//   },
//   {
//     title: 'email',
//     key: 'email',
//   },
//   {
//     title: 'role',
//     key: 'userGroups',
//     format: (x: number[]) => formatUserGroups(x, groupList),
//   },
//   {
//     title: 'state',
//     key: 'isActive',
//     format: (x: keyof typeof ACTIVE_LIST) => i18n.t(ACTIVE_LIST[x] || placeholder),
//   },
// ];

/** 表格列 */
const getColumns = (): CTableColumns => [
  {
    dataIndex: 'contactName',
    title: 'personnel_name',
    width: 180,
    fixed: 'left',
  },
  {
    dataIndex: 'email',
    title: 'email',

    width: 180,
  },
  {
    dataIndex: 'contactNumber',
    title: 'mobile_phone_number',
    width: 180,
  },
  {
    dataIndex: 'teamRole',
    title: 'role',
    width: 180,
    render: (x: string) => formatUserGroups(x),
  },
  {
    dataIndex: 'teamName',
    title: 'belonging_team',
    width: 180,
  },
  {
    dataIndex: 'isActive',
    title: 'state',
    width: 180,
    render: (_, record) => (
      <TableCell.Status
        statusKey='isActive'
        data={record}
        statusTextMap={{
          [ACTIVE.UN_ENABLE]: i18n.t('un_enable'),
          [ACTIVE.ENABLE]: i18n.t('enable'),
        }}
        statusColorMap={{
          [ACTIVE.UN_ENABLE]: 'error',
          [ACTIVE.ENABLE]: 'success',
        }}
      />
    ),
  },
];

/** 筛选配置 */
const getFilterProps = (placeholderTip: string) => ({
  mode: 'tags' as const,
  placeholder: i18n.t(placeholderTip),
  tokenSeparators: enterTokenSeparators,
  allowClear: true,
});

/** 筛选项 */
const getNewFilters = (): FilterConfig[] => {
  return [
    {
      filterKey: 'contactName',
      filterType: 'select',
      filterTitle: i18n.t('personnel_name'),
      filterProps: getFilterProps('enter_multiple'),
    },
    {
      filterKey: 'email',
      filterType: 'select',
      filterTitle: i18n.t('email'),
      filterProps: getFilterProps('enter_multiple'),
    },
    {
      filterKey: 'is_active',
      filterType: 'select',
      filterTitle: i18n.t('state'),
      filterProps: {
        options: Object.entries(ACTIVE_LIST).map(([key, value]) => ({
          label: i18n.t(value),
          value: key,
        })),
      },
    },
  ];
};

export { getColumns, getNewFilters };
